import { AUTO_CHALLENGE_RESPONSE_MESSAGE_ID, AUTO_CHALLENGE_STATUS_ID } from './challengeConstants';

/**
 *
 * @param {import("./autoChallenge").AutoChallengeResponseDTO} responseData
 * @returns {import('./autoChallenge').AutoChallengeInfo}
 */
export const extractAutoChallengeResponse = (responseData) => {
    /**
     * @type {import('./autoChallenge').AutoChallengeDTO | null}
     */
    let challenge = null;
    let hasChallenge = false;
    let challengeStatus = null;
    let startTime;
    let endTime;
    let isEnd;
    let joined = false;

    if (!responseData) {
        return {
            challenge,
            hasChallenge,
            challengeStatus,
            startTime,
            endTime,
            isEnd,
            joined
        };
    }
    const { reasonCode } = responseData;

    if (responseData.challengeDTOs) {
        challenge = responseData.challengeDTOs[0] || null;
    }

    if (reasonCode === AUTO_CHALLENGE_RESPONSE_MESSAGE_ID.UNKNOWN_REASON) {
        challengeStatus = AUTO_CHALLENGE_STATUS_ID.UNKNOWN;
    } else if (reasonCode === AUTO_CHALLENGE_RESPONSE_MESSAGE_ID.CHALLENGE_REQUEST_IS_IN_PENDING_STATE) {
        challengeStatus = AUTO_CHALLENGE_STATUS_ID.PENDING;
    } else if (reasonCode === AUTO_CHALLENGE_RESPONSE_MESSAGE_ID.HAS_CHALLENGE && challenge != null) {
        startTime = new Date(challenge.startTimeInTimezone);
        endTime = new Date(challenge.endTimeInTimezone);
        endTime.setSeconds(endTime.getSeconds() - 1);
        const now = new Date();
        isEnd = now.getTime() > endTime.getTime();
        if (isEnd) {
            challengeStatus = AUTO_CHALLENGE_STATUS_ID.IN_EVALUATION;
        } else {
            challengeStatus = AUTO_CHALLENGE_STATUS_ID.SHOW;
        }
    } else {
        challengeStatus = AUTO_CHALLENGE_STATUS_ID.NOT_IN_CHALLENGE;
    }

    switch (challengeStatus) {
        case AUTO_CHALLENGE_STATUS_ID.PENDING:
        case AUTO_CHALLENGE_STATUS_ID.SHOW:
        case AUTO_CHALLENGE_STATUS_ID.IN_EVALUATION:
            hasChallenge = challenge != null;
            break;
        default:
            hasChallenge = false;
            break;
    }

    return {
        challenge,
        hasChallenge,
        challengeStatus,
        startTime,
        endTime,
        isEnd,
        joined: challengeStatus !== AUTO_CHALLENGE_STATUS_ID.NOT_IN_CHALLENGE
    };
};
